import type { ThemeWithoutTokens } from '../theme.types';

export const typoTokens = (theme: ThemeWithoutTokens) =>
  ({
    // common
    typoTextColor: theme.colors.body.text,
    typoBackgroundColor: theme.colors.body.background,
    typoLetterSpacing: theme.typography.letterSpacing.m,
    typoFontFamily: theme.typography.fontFamily.regular,

    // heading 1
    typoHeading1FontWeight: theme.typography.fontWeight.bold,
    typoHeading1FontSize: theme.typography.fontSize.xxxl,
    typoHeading1LineHeight: theme.typography.lineHeight.xxxl,

    // heading 2
    typoHeading2FontWeight: theme.typography.fontWeight.bold,
    typoHeading2FontSize: theme.typography.fontSize.xxl,
    typoHeading2LineHeight: theme.typography.lineHeight.xxl,

    // heading 3
    typoHeading3FontWeight: theme.typography.fontWeight.bold,
    typoHeading3FontSize: theme.typography.fontSize.xl,
    typoHeading3LineHeight: theme.typography.lineHeight.xl,

    // heading 4
    typoHeading4FontWeight: theme.typography.fontWeight.bold,
    typoHeading4FontSize: theme.typography.fontSize.l,
    typoHeading4LineHeight: theme.typography.lineHeight.l,

    // heading 5
    typoHeading5FontWeight: theme.typography.fontWeight.bold,
    typoHeading5FontSize: theme.typography.fontSize.m,
    typoHeading5LineHeight: theme.typography.lineHeight.s,

    // subtitle
    typoSubtitleFontWeight: theme.typography.fontWeight.semibold,
    typoSubtitleFontSize: theme.typography.fontSize.m,
    typoSubtitleLineHeight: theme.typography.lineHeight.m,

    // subtitle-light
    typoSubtitleLightFontWeight: theme.typography.fontWeight.normal,
    typoSubtitleLightFontSize: theme.typography.fontSize.m,
    typoSubtitleLightLineHeight: theme.typography.lineHeight.m,

    // body
    bodyFontWeight: theme.typography.fontWeight.bold,
    bodyFontSize: theme.typography.fontSize.s,
    bodyLineHeight: theme.typography.lineHeight.s,

    // body-light
    bodyLightFontWeight: theme.typography.fontWeight.semibold,
    bodyLightFontSize: theme.typography.fontSize.s,
    bodyLightLineHeight: theme.typography.lineHeight.s,

    // body-lighter
    bodyLighterFontWeight: theme.typography.fontWeight.normal,
    bodyLighterFontSize: theme.typography.fontSize.s,
    bodyLighterLineHeight: theme.typography.lineHeight.s,

    // caption
    captionFontWeight: theme.typography.fontWeight.semibold,
    captionFontSize: theme.typography.fontSize.xs,
    captionLineHeight: theme.typography.lineHeight.xs,
  }) as const;
